export default function (router) {
    router.beforeEach((to, from, next) => {
        // Routes without middleware meta will be ignored and move on.
        if (! to.meta.middleware || ! to.meta.middleware.mustHasRoles) return next();

        const requiredRoles = to.meta.middleware.mustHasRoles;

        if (router.app.$store.getters['auth/hasRoles'](requiredRoles)) {
            return next();
        } else {
            next(from.path);
        }
    })
}